import PropTypes from 'prop-types';

function Button({
    className = '',
    containerType = 'main',
    name = '',
    size = 'medium',
    disabled,
    ...rest
}) {
    const isDisabled = disabled
        ? '!bg-inactive border-transparent cursor-not-allowed !text-disabled hover:!text-text-disabled active:!border-transparent'
        : '';

    const getSize = () => {
        if (size === 'medium') {
            return 'h-10 text-base';
        } else if (size === 'large') {
            return '!h-14 base';
        }
    };
    const getType = () => {
        switch (containerType) {
            case 'main':
                return 'bg-blue hover:bg-blue-button-hover text-light hover:text-light border-transparent active:border-focus';
            case 'yellow':
                return 'text-text-yellow bg-surface-yellow hover:bg-yellow hover:text-text-white border-transparent active:border-focus';
            case 'second':
                return 'bg-light text-dark hover:bg-blue hover:text-light border-blue hover:border-transparent active:border-focus';
            case 'danger':
                return 'text-text-white bg-error hover:bg-error-dark border-transparent active:border-error-light';
            case 'danger-second':
                return 'text-red bg-light hover:bg-text-light hover:bg-surface-error border-red active:border-error-light';
            default:
                return 'bg-blue hover:bg-blue-button-hover text-text-white border-transparent active:border-focus';
        }
    };

    return (
        <button
            className={`${disabled ? 'pointer-events-none' : 'group'} flex min-h-6 cursor-pointer items-center justify-center gap-2 rounded-3xl border-2 border-solid px-3 font-medium ${getType()} ${getSize()} ${isDisabled} ${className}`}
            {...rest}
        >
            {name}
        </button>
    );
}

Button.propTypes = {
    className: PropTypes.string,
    containerType: PropTypes.oneOf(['main', 'second', 'danger', 'yellow', 'danger-second']),
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.oneOf(['medium', 'large']),
    disabled: PropTypes.bool,
};

export default Button;
